import { Box } from '@mui/material';
import React from 'react';
import ReactPlayer from 'react-player';
import FileUploadProgress from './FileUploadProgress';
import { MessageStatus } from 'types/chat/messages/common';
import { MessageListRefProps } from 'types/chat/props';

interface VideoMessageProps {
  file: string;
  status: MessageStatus | null | undefined;
  scrollToBottom: MessageListRefProps['scrollToBottom'];
  mediaShouldScrollBottomRef: React.MutableRefObject<boolean>;
}

const VideoMessage: React.FC<VideoMessageProps> = ({
  file,
  status,
  scrollToBottom,
  mediaShouldScrollBottomRef,
}) => {
  const [playerSize, setPlayerSize] = React.useState<{
    width: number;
    height: number;
  }>({
    width: 200,
    height: 200,
  });

  const getVideoDimensions = React.useCallback((url: string) => {
    return new Promise<{
      width: number;
      height: number;
    } | null>((resolve, reject) => {
      const video = document.createElement('video');

      video.addEventListener('loadedmetadata', function () {
        const maxWidthDimension = 500;
        const maxHeightDimension = 400;
        let width, height;

        if (video.videoWidth > video.videoHeight) {
          width = video.videoWidth > maxWidthDimension ? maxWidthDimension : video.videoWidth;
          height = (width / video.videoWidth) * video.videoHeight;
        } else {
          height = video.videoHeight > maxHeightDimension ? maxHeightDimension : video.videoHeight;
          width = (height / video.videoHeight) * video.videoWidth;
        }

        resolve({
          width,
          height,
        });
      });

      video.addEventListener('error', function () {
        reject('Error while loading video');
      });

      video.src = url;

      video.load();
    });
  }, []);
  const applyPlayerSize = React.useCallback(
    async (url: string) => {
      const videoSize = await getVideoDimensions(url);
      if (typeof videoSize?.width === 'number' && typeof videoSize?.height === 'number') {
        setPlayerSize(videoSize);
        setTimeout(() => {
          mediaShouldScrollBottomRef.current && scrollToBottom(false);
        }, 50);
      }
    },
    [getVideoDimensions, mediaShouldScrollBottomRef, scrollToBottom],
  );

  React.useEffect(() => {
    applyPlayerSize(file);
  }, [file, applyPlayerSize]);

  return (
    <Box
      sx={{
        maxWidth: '100%',
        maxHeight: '100%',
        margin: '0 auto !important',
        position: 'relative',
      }}
    >
      {status === 'uploading' ? (
        <React.Fragment>
          <FileUploadProgress interval={300} />
          <video
            muted
            src={file}
            style={{
              maxWidth: '100%',
              width: '100%',
              maxHeight: 400,
              minHeight: 100,
              display: 'block',
            }}
          />
        </React.Fragment>
      ) : (
        <ReactPlayer
          url={file}
          style={{
            maxWidth: '100%',
            maxHeight: 400,
            minHeight: 100,
          }}
          width={playerSize.width}
          height={playerSize.height}
          controls={true}
          // onReady={() => }
          // light={true}
        />
      )}
    </Box>
  );
};

export default VideoMessage;
